import { registerSurfaceItem } from "@/lib/surfaces";
import { lazyNamed } from "@/lib/lazyNamed";

/** US-010 — audit domain dashboard contributions. */
registerSurfaceItem("dashboard-banners", {
  id: "audit-banners",
  order: 20,
  // SCRUM-148: only mount for roles that can read audit data (matches the
  // backend audit:read gate) so an assumed non-audit role doesn't render the
  // card or fire its audit-requests query.
  access: { resource: "audit" },
  Component: lazyNamed(() => import("./AuditBannersCard"), "AuditBannersCard"),
});

registerSurfaceItem("dashboard-highlights", {
  id: "audit-overview",
  order: 20,
  Component: lazyNamed(
    () => import("./AuditOverviewWidget"),
    "AuditOverviewWidget",
  ),
});

registerSurfaceItem("dashboard-tables", {
  id: "activity-log",
  order: 30,
  Component: lazyNamed(() => import("./ActivityLogCard"), "ActivityLogCard"),
});
